export default {"src":"/_next/static/media/image-solid.aec905e9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};